import React from 'react';
import { Tag } from 'antd';
import {
  DATETIME_FORMAT_DATE,
  DATETIME_FORMAT_DATETIME,
  DATETIME_FORMAT_DATETIME_DB,
  getSearchTypeName,
} from '../../../../../utils/helpers/CommonHelper.jsx';
import { useTranslation } from 'react-i18next';
import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import {
  ClockCircleOutlined,
  DesktopOutlined,
  FilePdfOutlined,
  IdcardOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

const SearchResultItem = ({ hit, simpleResults, onSelect }) => {
  const { t } = useTranslation();

  // Get the full title from the fields
  const fullTitle = hit.title_sk || hit.title_en || '';

  // Get the highlight fragment for the title (if exists)
  const highlightFragment =
    hit.highlight?.title_sk?.[0] ||
    hit.highlight?.['title_sk.autocomplete']?.[0] ||
    hit.highlight?.title_en?.[0] ||
    hit.highlight?.['title_en.autocomplete']?.[0];

  // Merge function to combine the full title with the highlighted fragment
  const mergeTitle = (fullTitle, highlightFragment) => {
    if (!highlightFragment) return fullTitle;
    // Create a temporary element to strip out HTML from the highlight fragment
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = highlightFragment;
    const plainHighlight = tempDiv.textContent || tempDiv.innerText || '';

    // Find the plain text substring in the full title (case-insensitive)
    const index = fullTitle.toLowerCase().indexOf(plainHighlight.toLowerCase());
    if (index !== -1) {
      // Replace that substring with the highlighted fragment
      return (
        fullTitle.substring(0, index) +
        highlightFragment +
        fullTitle.substring(index + plainHighlight.length)
      );
    }
    return fullTitle;
  };

  // Get the final title with highlight merged in
  const finalTitle = mergeTitle(fullTitle, highlightFragment);

  const renderTag = (model_type) => {
    const tagText = `${capitalize(t(getSearchTypeName(model_type)))}`;
    switch (model_type) {
      case 'departments':
        return (
          <Tag icon={<TeamOutlined />} color="blue">
            {tagText}
          </Tag>
        );
      case 'articles':
        return (
          <Tag icon={<DesktopOutlined />} color="green">
            {tagText}
          </Tag>
        );
      case 'news':
        return (
          <Tag icon={<ClockCircleOutlined />} color="orange">
            {tagText}
          </Tag>
        );
      case 'teachers':
        return (
          <Tag icon={<IdcardOutlined />} color="purple">
            {tagText}
          </Tag>
        );
      case 'files':
        return (
          <Tag icon={<FilePdfOutlined />} color="gray">
            {tagText}
          </Tag>
        );
      default:
        return <Tag color="default">{model_type}</Tag>;
    }
  };

  // Combine highlight fragments for content if available
  const highlightContent =
    hit.highlight?.content_sk?.join(' ... ') ||
    hit.highlight?.['content_sk.autocomplete']?.join(' ... ') ||
    hit.highlight?.content_en?.join(' ... ') ||
    hit.highlight?.['content_en.autocomplete']?.join(' ... ');

  return (
    <div
      className={'search-result-item-container'}
      onClick={() => {
        onSelect(hit.frontend_url, hit.model_type);
      }}
    >
      <a className={'search-result-item-title'} href={hit.frontend_url}>
        <span dangerouslySetInnerHTML={{ __html: finalTitle }} />
      </a>
      {hit.location_sk && (
        <div className={'search-result-item-location'}>
          <span className={'menu'}>Menu:</span> {hit.location_sk}
        </div>
      )}
      {/*<div className={'search-result-item-url'}>*/}
      {/*  {`${window.location.origin}${hit.frontend_url}`}*/}
      {/*</div>*/}
      {highlightContent && (
        <div
          className={'search-result-item-content'}
          dangerouslySetInnerHTML={{ __html: highlightContent }}
        />
      )}
      <div className={'search-result-item-footer'}>
        {renderTag(hit.model_type)}
        {hit.created_at && (
          <span>
            {'| '}
            {dayjs(hit.created_at).format(DATETIME_FORMAT_DATETIME)}
          </span>
        )}
      </div>
    </div>
  );
};

SearchResultItem.propTypes = {
  hit: PropTypes.object,
  simpleResults: PropTypes.bool,
  onSelect: PropTypes.func,
};

//export default React.memo(SearchResultItem);
export default SearchResultItem;
